import React, { useEffect } from 'react';
import { RootState } from 'model';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { closeMeeting, continueMeeting, getContinueMeetingOperation, getMeetingDetails } from 'model/meeting';
import Loading from 'component/Loading';
import TitlePanel from 'component/TitlePanel';
import MeetingInfo from '../Details/component/MeetingInfo';
import ContinueTip from './components/ContinueTip';
import ContinueResult from './components/ContinueResult';
import { Modal } from 'antd';
import APP_ROUTE from 'constant/route';

import styles from './index.module.scss';
import { MeetingState } from 'type/meeting';

const ErarlyEnd: React.FC = () => {
  const dispatch = useDispatch();
  // 会议信息
  const meeting = useSelector((state: RootState) => state.meeting.meetingInfo);
  // 是否有继续会议操作
  const hasContinueOperation = useSelector((state: RootState) => state.meeting.hasContinueOperation);

  const params: { id: string } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (!params.id) return;
    // 拉取会议详情
    dispatch(getMeetingDetails(params.id));
    // 查询是否操作过会议继续
    dispatch(getContinueMeetingOperation(params.id));
  }, [params.id]);

  useEffect(() => {
    if (!meeting) return;
    // 非会议中状态 跳转至会议详情页
    if (meeting.state !== MeetingState.BEGIN) {
      goToMeetingDetail();
    }
  }, [meeting]);

  const continueResultHandle = () => {
    history.replace(APP_ROUTE.SCHEDULE);
  };

  const continueMeetingHandle = () => {
    if (!meeting) return;
    dispatch(continueMeeting(meeting._id));
  };

  const endMeetingHandle = () => {
    if (!meeting) return;
    Modal.confirm({
      title: '提前结束',
      icon: '',
      content: '确定要提前结束会议吗？',
      okText: '提前结束',
      cancelText: '取消',
      onOk: () => {
        dispatch(closeMeeting(meeting));
      },
      centered: true,
      autoFocusButton: null
    });
  };

  const goToMeetingDetail = () => {
    meeting && history.replace('/details/' + meeting._id);
  };

  return (
    <div className={styles.container}>
      {!meeting ? (
        <Loading></Loading>
      ) : hasContinueOperation ? (
        <ContinueResult onKnow={continueResultHandle} />
      ) : (
        <TitlePanel>
          <div className={styles.card}>
            <MeetingInfo info={meeting} isCreator={true} showAction={false} />
          </div>
          <div className={styles.card}>
            <ContinueTip onEndMeeting={endMeetingHandle} onContinueMeeting={continueMeetingHandle} />
          </div>
        </TitlePanel>
      )}
    </div>
  );
};

export default ErarlyEnd;
